import { createReducer } from 'redux-act';
import { PROMO_AREA_STATES } from 'lib/enums/search';
import {
  clearDeals,
  fetchDeals,
  fetchDealsSuccess,
  fetchDealsFailure,
  setLoading,
  setComponentState,
  setActiveCategory,
} from './promoAreaActions';

const initialState = {
  activeCategory: {},
  componentState: PROMO_AREA_STATES.EXPANDED,
  deals: [],
  error: null,
  isLoading: true,
  meta: {},
};

export const reducer = createReducer(
  {
    [clearDeals]: (state) => ({ ...state, deals: [], meta: {} }),
    [fetchDeals]: (state) => ({ ...state, error: null }),
    [fetchDealsSuccess]: (state, { deals, meta }) => ({ ...state, deals, meta }),
    [fetchDealsFailure]: (state, error) => ({ ...state, deals: [], meta: {}, error }),
    [setActiveCategory]: (state, payload) => ({ ...state, activeCategory: payload }),
    [setComponentState]: (state, payload) => ({ ...state, componentState: payload }),
    [setLoading]: (state, payload) => ({ ...state, isLoading: payload }),
  },
  initialState,
);
